module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center",
    style: ({
      height: _vm.Height + 'px'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.pageLoader_img
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.Message))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9ee12de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9ee12de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MessageLoader.vue
// module id = 561
// module chunks = 3